import {
  attachDerivedTopicSelection,
  deriveTopicFromAddressByZoom,
  selectDerivedLocationName,
  selectDerivedLocationTopicMeta,
  useAppStore,
} from '../app/store';
import { useShallow } from 'zustand/react/shallow';

export { attachDerivedTopicSelection, deriveTopicFromAddressByZoom };

export const setDisplayLocation = (dataOrUpdater) => {
  const previous = useAppStore.getState().displayLocation;
  const nextValue = typeof dataOrUpdater === 'function'
    ? dataOrUpdater(previous)
    : dataOrUpdater;

  useAppStore.getState().dispatch({
    type: 'setDisplayLocation',
    value: nextValue,
  });
};

export const setMapZoom = (zoom) => {
  useAppStore.getState().dispatch({
    type: 'setMapZoom',
    value: zoom,
  });
};

export const useDisplayLocation = () => useAppStore((state) => state.displayLocation);
export const useDerivedLocationName = () => useAppStore(selectDerivedLocationName);
export const useDerivedLocationTopicMeta = () => useAppStore(useShallow(selectDerivedLocationTopicMeta));
